import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminUser = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(
        'https://api.bakpoket.com/api/AdminUsers/Users'
      );

      console.log("FULL RESPONSE:", res);
      console.log("RESPONSE DATA:", res.data);

      const data = res.data.data || res.data;
      setUsers(data);

    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  return (
    <div>
      <h2>Admin Users</h2>

      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Username</th>
          </tr>
        </thead>

        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="4">No Data Found</td>
            </tr>
          ) : (
            users.map((user, index) => (
              <tr key={user.id || index}>
                <td>{user.id}</td>
                <td>{user.emailAddress}</td>
                <td>{user.mobileNumber}</td>
                <td>{user.userName}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUser;